import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS} from './_base';

import I_ALERT,{I_PREF_ALERT} from '../interfaces/I_ALERTS';
import {
  getAlertsResponse,
  getPrefsAlertsResponse,
  setPrefAlertsResponse,
  acknowledgeAlertResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- ALERTS
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  user_id: number;
}
/**
 * Récupère la liste des alertes
 * @param obj
 * @returns
 */
const getList = async ({
  accessToken,refreshToken,
  dispatch,state,
  user_id,
}:I_GET_PARAMS):Promise<I_ALERT[]> => {
  logger.debug('ApiServices - getAlerts - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getAlertsResponse({
        accessToken:usedAccessToken,
        user_id,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getAlerts - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_ALERT[] = await response.json();
  logger.debug('ApiServices - getAlerts - ok, returned body',body);
  return body;
};


/**
 * Récupère la liste des preferences
 * @param obj
 * @returns
 */
const getPreferences = async ({
  accessToken,refreshToken,
  dispatch,state,
  user_id,
}:I_GET_PARAMS):Promise<I_PREF_ALERT[]> => {
  logger.debug('ApiServices - getPreferences - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPrefsAlertsResponse({
        accessToken:usedAccessToken,
        user_id,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPreferences - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PREF_ALERT[] = await response.json();
  logger.debug('ApiServices - getPreferences - ok, returned body',body);
  return body;
};






interface I_CREATE_PARAMS {
  accessToken: string,
  refreshToken: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401

  user_id: number;
  preferences: I_PREF_ALERT[];
}
/**
 * Crée une preference d'alerte
 * @param param0
 * @returns
 */
const setPreferences = async ({
  accessToken,refreshToken,
  dispatch,state,
  user_id,
  preferences,
}:I_CREATE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - setPreferences - ...');
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return setPrefAlertsResponse({
        accessToken:usedAccessToken,
        user_id,
        preferences,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - setPreferences - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - setPreferences - ok, returned body',body);
  logger.info(...formatInfo('Alerts preferences set!'));
  return body;
};


interface I_ACQ_PARAMS {
  accessToken: string,
  refreshToken: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401

  user_id: number;
  alert_id: number;
}
/**
 * Acquitte une alerte
 * @param param0
 * @returns
 */
const acknowledge = async ({
  accessToken,refreshToken,
  dispatch,state,
  user_id,
  alert_id,
}:I_ACQ_PARAMS):Promise<string> => {
  logger.debug('ApiServices - acknowledge - ...');
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return acknowledgeAlertResponse({
        accessToken:usedAccessToken,
        user_id,
        alert_id,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - acknowledge - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - acknowledge - ok, returned body',body);
  logger.info(...formatInfo('Alert acknowledged!'));
  return body;
};

const AlertsServices = {
  getList,
  getPreferences,
  setPreferences,
  acknowledge,
};

export default AlertsServices;
